import { GraphQueryTemplate } from 'dashboard/models/graph-query-template';
import Action from 'lib/interfaces/Action';

export type GraphQueryTemplateAction = SetGraphQueryTemplateAction | ClearGraphQueryTemplateAction;

export enum GraphQueryTemplateActionType {
  Set = 'graph-query-template/SET',
  Clear = 'graph-query-template/CLEAR',
}

interface SetGraphQueryTemplatePayload {
  graphQueryTemplate: GraphQueryTemplate;
}

export type SetGraphQueryTemplateAction = Action<
  GraphQueryTemplateActionType.Set,
  SetGraphQueryTemplatePayload
>;

export type ClearGraphQueryTemplateAction = Action<GraphQueryTemplateActionType.Clear>;

export function setGraphQueryTemplate(
  graphQueryTemplate: GraphQueryTemplate,
): SetGraphQueryTemplateAction {
  return {
    payload: {
      graphQueryTemplate,
    },
    type: GraphQueryTemplateActionType.Set,
  };
}

export function clearGraphQueryTemplate(): ClearGraphQueryTemplateAction {
  return {
    type: GraphQueryTemplateActionType.Clear,
  };
}
